export default {
  location: [],
  loadingCount: 0,
  systemMessage: {
    show: false,
    message: null,
    color: null,
    timeout: -1,
    light: false,
    title: null,
    icon: null,
  },
}
